import React from "react";
import Reveal from "../../components/reveal/Reveal";
import rehabPhoto from "../../assets/blogphoto/rd13.jpg";
import preventionPhoto from "../../assets/blogphoto/stp53.jpg";
import aidPhoto from "../../assets/blogphoto/psis13.jpg";
import partnersPhoto from "../../assets/blogphoto/bgc22.jpg";
import "./programs.css";

/* An index of what we run, numbered like entries in a report. Photographs of
   the actual work instead of icons — an icon of a wheelchair says nothing a
   photograph of the room does not say better. */
const PROGRAMS = [
  {
    title: "Rehabilitation after stroke and paralysis",
    body: "Physiotherapy, mobility support and follow-up care for people whose recovery would otherwise stop at the hospital door.",
    note: "Ongoing",
    photo: rehabPhoto,
    alt: "A man with a head dressing sitting in a therapy room.",
  },
  {
    title: "Stroke prevention awareness",
    body: "Community sessions on the warning signs, risk factors and what to do in the first hour — held where medical information rarely reaches.",
    note: "By session",
    photo: preventionPhoto,
    alt: "People seated in a circle at a SALES stroke prevention and rehabilitation workshop.",
  },
  {
    title: "Help with the cost of treatment",
    body: "Direct financial assistance towards medicine, physiotherapy and rehabilitation for families who cannot carry it alone.",
    note: "Case by case",
    photo: aidPhoto,
    alt: "A boy receiving a gift box at a distribution event.",
  },
  {
    title: "Partnerships for inclusion",
    body: "Work alongside SPRC Barishal, Shomota Inclusive School and Generation Bangladesh so children with disabilities stay in school and in care.",
    note: "Three partners",
    photo: partnersPhoto,
    alt: "Staff and families at a health screening table under a tin roof.",
  },
];

const Programs = () => (
  <section
    className="section programs"
    id="features"
    aria-labelledby="programs-title"
  >
    <div className="shell">
      <p className="marker">
        <span className="marker__num">02</span>
        <span>Our work</span>
      </p>

      <div className="programs__head">
        <h2 id="programs-title" className="t-h2 programs__title">
          Four things we do, and keep doing.
        </h2>
        <p className="t-lead programs__intro">
          Each one exists because a family in Barishal asked for it. None of it
          works without the next donation.
        </p>
      </div>

      <ol className="programs__index">
        {PROGRAMS.map((program, i) => (
          <Reveal
            as="li"
            className="program"
            key={program.title}
            delay={i * 70}
            distance={18}
          >
            <span className="program__num" aria-hidden="true">
              {String(i + 1).padStart(2, "0")}
            </span>

            <div className="program__text">
              <h3 className="t-h3 program__title">{program.title}</h3>
              <p className="t-body program__body">{program.body}</p>
            </div>

            <span className="program__note">{program.note}</span>

            <img
              className="program__photo"
              src={program.photo}
              alt={program.alt}
              loading="lazy"
              decoding="async"
            />
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);

export default Programs;
